import React from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import './CrossClientProgress.scss'

export interface CrossClientProgressProps {
  total: number
  done: number
}

export const CrossClientProgress: React.FC<CrossClientProgressProps> = ({ total, done }) => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center position-relative cross-client-progress-chart-container'>
      <PieChart
        data={[
          { title: 'Done', value: done, color: 'var(--zocks-primary)' },
          { title: 'Total', value: total - done, color: '#E9ECEF' },
        ]}
        lineWidth={30}
        totalValue={total}
        startAngle={270}
      />
      <div className='paragraph-medium medium position-absolute'>{Math.floor((done / total) * 100)}%</div>
    </div>
  )
}
